<template>
    <div class="foot">

      <van-tabbar v-model="active" class="foot" route>
        <van-tabbar-item to="/">
          <span>{{this.$t('sy')}}</span>
          <template #icon="props">
            <img :src="props.active ? icon.active : icon.inactive" />
          </template>
        </van-tabbar-item>
        
        <!-- <van-tabbar-item to="/selfreg" v-if="person_type !=1">
          <span>{{this.$t('zzzc')}}</span>
          <template #icon="props">
            <img :src="props.active ? icon2.active : icon2.inactive" />
          </template>
        </van-tabbar-item> -->

        <van-tabbar-item to="/equipment">
          <span>{{this.$t('sb')}}</span>
          <template #icon="props">
            <img :src="props.active ? icon3.active : icon3.inactive" />
          </template>
        </van-tabbar-item>
        
        <van-tabbar-item :to="path">
            <span>{{this.$t('wd')}}</span>       
            <template #icon="props">
                <img :src="props.active ? icon4.active : icon4.inactive" />
            </template>
        </van-tabbar-item>

      </van-tabbar>
    </div>
</template>

<script>
export default {
  props: {
    actives: {
      // 规定传值为字符串 默认的名字
      type: Number
    },
    person_type:{
		type: Number
	}
  },
  // computed:{
  //   active:function(){
  //     return Number(active)
  //   }
  // },
  mounted(){
    console.log(this.path)
    this.active = this.actives
  },
  data(){
    return{
      path:'/about',
      active: null,
      icon: {
        active: require('@/assets/images/tabbar/home.png'),
        inactive: require('@/assets/images/tabbar/home_h.png'),
      },
      icon2: {
        active: require('@/assets/images/tabbar/register.png'),
        inactive: require('@/assets/images/tabbar/register_h.png'),
      },
      icon3: {
        active: require('@/assets/images/tabbar/device.png'),
        inactive: require('@/assets/images/tabbar/device_h.png'),
      },
      icon4: {
        active: require('@/assets/images/tabbar/user.png'),
        inactive: require('@/assets/images/tabbar/user_h.png'),
      },
    }
  },
  methods:{
    ss(){
      this.path = '/about'
    }
  }
    
    
}
</script>

<style scoped>
.foot{
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    box-sizing: content-box;
    height: 50px;
    background-color: #1ABC9C;
    justify-content: space-around;
  }
  .foot p{
    margin: 0px;
    color: #fff;
    font-size: 14px;
  }
  .foot >>>.van-tabbar{
    background-color: none;
  }
  .foot >>>.van-tabbar-item--active{
    background-color: #1ABC9C;
    color:white;
  }
</style>